import { api } from '../../../lib/api';
import type { ListQuery, PagedResult } from '../../administration/users/userTypes';
import type {
  BudgetAccountCodeListItem,
  BudgetAccountCodeOption,
  BudgetAccountCodeRequest,
} from './budgetCatalogTypes';

function toQueryString(query: ListQuery): string {
  const params = new URLSearchParams();

  if (query.search?.trim()) params.set('search', query.search.trim());
  if (query.page && query.page > 1) params.set('page', String(query.page));
  if (query.pageSize) params.set('pageSize', String(query.pageSize));
  if (query.sort) params.set('sort', query.sort);
  /*
    Sent whenever the key is present, empty string included — an empty value is the reader
    saying "none of these", which matches no row.
  */
  if (query.status !== undefined) params.set('status', query.status);

  const serialized = params.toString();
  return serialized ? `?${serialized}` : '';
}

export const budgetAccountCodesApi = {
  clear: () => api<number>('/api/budget-account-codes/clear', { method: 'POST' }),

  list: (query: ListQuery, signal?: AbortSignal) =>
    api<PagedResult<BudgetAccountCodeListItem>>(
      `/api/budget-account-codes${toQueryString(query)}`,
      { signal },
    ),

  get: (id: string, signal?: AbortSignal) =>
    api<BudgetAccountCodeListItem>(`/api/budget-account-codes/${id}`, { signal }),

  /** Active accounts for a budget line item's picker. Unpaged. */
  options: (signal?: AbortSignal) =>
    api<BudgetAccountCodeOption[]>('/api/budget-account-codes/options', { signal }),

  create: (request: BudgetAccountCodeRequest) =>
    api<BudgetAccountCodeListItem>('/api/budget-account-codes', { method: 'POST', body: request }),

  update: (id: string, request: BudgetAccountCodeRequest) =>
    api<BudgetAccountCodeListItem>(`/api/budget-account-codes/${id}`, { method: 'PUT', body: request }),

  deactivate: (id: string) => api<void>(`/api/budget-account-codes/${id}`, { method: 'DELETE' }),

  activate: (id: string) => api<void>(`/api/budget-account-codes/${id}/restore`, { method: 'POST' }),
};
